var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMail = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 18 14"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#FFF",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M14.973 12.76H3.027c-.942 0-1.707-.799-1.707-1.783V3.023c0-.984.765-1.783 1.707-1.783h11.946c.942 0 1.707.799 1.707 1.783v7.954c0 .984-.765 1.783-1.707 1.783m1.707-9.737-5.716 3.683a3.09 3.09 0 0 1-3.928 0L1.32 3.023"
})));
export default SvgMail;